import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheCryptHelper} from "../utils/TheCryptHelper";
import {Sprite} from "pixi.js";
import Spine = PIXI.spine.Spine;
import {TheCrypt} from "../TheCrypt";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class TheCryptBackground extends PIXI.Container implements StageLayer {

    //landscape, portrait_normal, portrait_fs
    private readonly GAME_LOGO_POSITION_Y: number[] = [53, -150, -200];
    private _spines: PIXI.spine.Spine[];
    private _mainGameBG: PIXI.Container;
    private _bonusGameBG: PIXI.Container;
    private _fsAnimation: Spine;
    private _gameNameAndWays: PIXI.Container;
    private _topGradient: PIXI.Sprite;
    private _gameLogoOnTop: PIXI.Sprite;
    private _gameLogoportraitPositionY: number;

    constructor() {
        super();
        this.name = "Background";
        this._spines = [];
        this.init();
    }

    private init() {
        const mainBG: Sprite = TheCryptHelper.createSprite("introBg", 360, 360);
        mainBG.anchor.set(0.5, 0.5);
        this.addChild(mainBG);
        this._topGradient = TheCryptHelper.createSprite("dark_gradient", 360, 0);
        this._topGradient.anchor.set(0.5, 0);
        this._topGradient.alpha = 0.3;
        this._topGradient.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        this.addChild(this._topGradient);
        this._mainGameBG = this.addNormalBGAnimation();
        this._bonusGameBG = this.addFSBGAnimation();
        this._gameNameAndWays = this.addGameNameAndWays();

        this._gameLogoOnTop = TheCryptHelper.createSprite("logo", 0, 0);
        this._gameLogoOnTop.name = "logo";
        this.addChild(this._gameLogoOnTop);
        this._gameLogoOnTop.scale.set(0.8);
        this._gameLogoOnTop.anchor.set(0.5);
        this._gameLogoportraitPositionY = this.GAME_LOGO_POSITION_Y[TheCrypt.model.isNormal ? 1 : 2]
        this.onResize();
    }

    private addNormalBGAnimation(): PIXI.Container {
        const normalBgContainer: PIXI.Container = new PIXI.Container();
        normalBgContainer.name = "mainGameBGContainer";

        return normalBgContainer;
    }

    private addGameNameAndWays(): PIXI.Container {
        const gameNameAndWays: PIXI.Container = new PIXI.Container();
        gameNameAndWays.name = "gameNameAndWays";

        return gameNameAndWays;
    }

    private addFSBGAnimation(): PIXI.Container {
        const fsBgContainer: PIXI.Container = new PIXI.Container();
        fsBgContainer.name = "bonusGameBGContainer";
        this._fsAnimation = new PIXI.spine.Spine(TheCrypt.assetLoader.getSpineAsset("FS_background"));
        this._fsAnimation.position.set(360, 360);
        fsBgContainer.addChild(this._fsAnimation);
        return fsBgContainer;
    }

    public setMode(mode: string): void {
        if (TheCryptHelper.isNormal(mode)) {
            this._bonusGameBG.visible = false;
            this.addChild(this._mainGameBG);
            this._gameLogoportraitPositionY = this.GAME_LOGO_POSITION_Y[1];
        } else {
            this._bonusGameBG.visible = true;
            this._gameLogoportraitPositionY = this.GAME_LOGO_POSITION_Y[2];
            this.addChild(this._bonusGameBG);
        }
        this.onRePositionLogo();
        this.addChild(this._gameNameAndWays);
    }

    public onRePositionLogo() {
        const isLandscape: boolean = NolimitApplication.isLandscape,
            logoY: number = Math.max(this._gameLogoportraitPositionY, NolimitApplication.screenBounds.top + 50);
        if (isLandscape) {
            this._gameLogoOnTop.position.set(-174, 53);
            this._gameLogoOnTop.visible = (-174 - NolimitApplication.screenBounds.left)>30;
        } else {
            this._gameLogoOnTop.position.set(360, Math.min(logoY, -88));
            this._gameLogoOnTop.visible = (Math.min(logoY, -88) - NolimitApplication.screenBounds.top)>(TheCrypt.model.isNextNormal?35:50);
        }

    }

    public onResize() {
        const isLandscape: boolean = NolimitApplication.isLandscape;
        if (this._bonusGameBG.visible && this._fsAnimation) {
            this._fsAnimation.state.setAnimation(0, isLandscape ? "landscape" : "portrait", true);
        }
        this.onRePositionLogo();
        this._topGradient.width = NolimitApplication.screenBounds.width;
        this._topGradient.position.y = NolimitApplication.screenBounds.top;
    }

}